import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext({ discountCents: 0, pointsPerDollar: 10, pointsPerDollarRedeem: 200, freeShipThreshold: 0, testMode: false });
export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  const [discountCents, setDiscountCents] = useState(0);
  const [pointsPerDollar, setPointsPerDollar] = useState(10);
  const [pointsPerDollarRedeem, setPointsPerDollarRedeem] = useState(200);
  const [freeShipThreshold, setFreeShipThreshold] = useState(0);
  const [testMode, setTestMode] = useState(false);
  const [garmentColors, setGarmentColors] = useState([]);

  useEffect(() => {
    api
      .get("/config")
      .then((r) => {
        setDiscountCents(r.data.discount_cents || 0);
        if (r.data.points_per_dollar) setPointsPerDollar(r.data.points_per_dollar);
        if (r.data.points_per_dollar_redeem) setPointsPerDollarRedeem(r.data.points_per_dollar_redeem);
        setFreeShipThreshold(r.data.free_shipping_threshold_cents || 0);
        setTestMode(!!r.data.test_mode);
        setGarmentColors(r.data.garment_colors || []);
      })
      .catch(() => {});
  }, []);

  return (
    <SettingsContext.Provider value={{ discountCents, pointsPerDollar, pointsPerDollarRedeem, freeShipThreshold, testMode, garmentColors }}>
      {children}
    </SettingsContext.Provider>
  );
};
